/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowADownRightIcon16Solid = forwardRef('ArrowADownRightIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.482 11.25H5.5a1.25 1.25 0 1 0 0 2.5h6a2.25 2.25 0 0 0 2.25-2.25v-6a1.25 1.25 0 1 0-2.5 0v3.982L4.384 2.616a1.25 1.25 0 1 0-1.768 1.768l6.866 6.866Z" })));
});
